var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrokerConnectIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 520 344",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_91_4753)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 520,
    height: 344,
    rx: 16,
    fill: "#002D9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3521 258.007C-2.44932 96.5726 150.494 133.649 248.87 175.854C482.502 276.085 477.885 228.455 410.841 107.158",
    stroke: "#0078FF",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 254.473,
    cy: 177.187,
    r: 90.6773,
    fill: "#D0E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.571 141.287H261.69L243.505 158.735C239.925 162.17 239.858 167.874 243.357 171.392L246.342 174.394C249.689 177.759 255.091 177.894 258.602 174.701L263.413 170.325L292.183 199.62C295.434 202.93 295.585 208.186 292.53 211.678L288.276 216.539C285.045 220.233 279.429 220.601 275.743 217.361L275.59 217.226L273.667 219.153C270.201 222.628 264.572 222.628 261.106 219.153L259.184 217.226L257.301 219.114C253.819 222.604 248.161 222.586 244.701 219.075L224.756 198.834H201.468C196.568 198.834 192.596 194.862 192.596 189.962V167.088C192.596 162.188 196.568 158.216 201.468 158.216H209.002L223.29 143.893C224.955 142.225 227.215 141.287 229.571 141.287Z",
    fill: "#A6C8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.154 177.98L263.975 170.792L278.404 185.545L292.833 200.297H310.111C315.01 200.297 318.982 196.325 318.982 191.425V167.088C318.982 162.188 315.01 158.216 310.111 158.216H290.996L273.524 140.701C270.101 137.27 264.557 137.221 261.074 140.592L239.952 161.032C236.393 164.476 236.343 170.167 239.84 173.673L243.87 177.713C247.231 181.082 252.651 181.199 256.154 177.98Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.273,
    y: 152.258,
    width: 26.6147,
    height: 51.0115,
    rx: 4.43578,
    fill: "#0078FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.726,
    y: 152.258,
    width: 26.6147,
    height: 51.0115,
    rx: 4.43578,
    fill: "#001D6C"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_91_4753)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.8605,
    y: 224.044,
    width: 71.4055,
    height: 71.4055,
    rx: 35.7028,
    fill: "#A6C8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7169 275.498C76.7169 269.408 81.6534 264.472 87.7428 264.472H101.394C107.483 264.472 112.42 269.408 112.42 275.498C112.42 277.527 110.774 279.173 108.744 279.173H80.3922C78.3624 279.173 76.7169 277.527 76.7169 275.498Z",
    fill: "#001D6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.091,
    cy: 250.295,
    r: 11.3759,
    fill: "#001D6C"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_91_4753)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 32.9875,
    width: 44.9568,
    height: 44.9568,
    rx: 22.4784,
    fill: "#0043CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.242 65.3828C131.242 61.5489 134.35 58.4409 138.184 58.4409H146.779C150.613 58.4409 153.721 61.5489 153.721 65.3828C153.721 66.6607 152.685 67.6967 151.407 67.6967H133.556C132.278 67.6967 131.242 66.6607 131.242 65.3828Z",
    fill: "#001D6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 142.811,
    cy: 49.5153,
    r: 7.16223,
    fill: "#001D6C"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_91_4753)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 353,
    y: 282,
    width: 86,
    height: 86,
    rx: 43,
    fill: "#0078FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.506 343.97C374.506 336.636 380.451 330.691 387.785 330.691H404.226C411.56 330.691 417.506 336.636 417.506 343.97C417.506 346.415 415.524 348.397 413.079 348.397H378.932C376.488 348.397 374.506 346.415 374.506 343.97Z",
    fill: "#001D6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396.635,
    cy: 313.617,
    r: 13.701,
    fill: "#001D6C"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_91_4753)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 411.661,
    cy: 97.8342,
    r: 49.3391,
    fill: "#A6C8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.897 72.9133C392.897 69.646 395.545 66.9973 398.813 66.9973H425.494C428.761 66.9973 431.41 69.646 431.41 72.9133V123.804H392.897V72.9133Z",
    fill: "#001D6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.509 107.435C404.509 103.181 407.957 99.7329 412.211 99.7329C416.465 99.7329 419.914 103.181 419.914 107.435V123.803H404.509V107.435Z",
    fill: "#A6C8FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.509,
    y: 88.6614,
    width: 15.4052,
    height: 3.85129,
    rx: 1.92564,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.509,
    y: 78.5505,
    width: 15.4052,
    height: 3.85129,
    rx: 1.92564,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.991 122.504H436.33",
    stroke: "#001D6C",
    strokeWidth: 5.33396,
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_91_4753",
    x: 41.0091,
    y: 215.118,
    width: 107.108,
    height: 107.108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.92569
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.92569
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_91_4753"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_91_4753",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_91_4753",
    x: 108.761,
    y: 27.368,
    width: 67.4352,
    height: 67.4352,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.6196
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.6196
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_91_4753"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_91_4753",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_91_4753",
    x: 331.5,
    y: 271.25,
    width: 129,
    height: 129,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.75
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_91_4753"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_91_4753",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_91_4753",
    x: 340.986,
    y: 37.8272,
    width: 141.35,
    height: 141.35,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.6679
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.6679
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_91_4753"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_91_4753",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_91_4753"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 520,
    height: 344,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokerConnectIllustration);
export default __webpack_public_path__ + "static/media/broker-connect-illustration.e873ca6550c4ce055c9e1a194542aadf.svg";
export { ForwardRef as ReactComponent };